import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import VizsgaFeladatTableDto from '../dto/VizsgaFeladatTableDto';

class VizsgaFeladatTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'vizsgafeladatTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<VizsgaFeladatTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, VizsgaFeladatTableDto)))
				.catch(reject);
		});
	}
}

export default new VizsgaFeladatTableService();
